export { Action } from 'pkg/api/models/allowed_actionable';

export * as account from './account';
export * as aiConversation from './ai_conversation';
export * as aiMessage from './ai_message';
export * as aiMessageRating from './ai_message_rating';
export * as accountInvite from './account_invite';
export * as accountNotification from './account_notification';
export * as accountRelation from './account_relation';
export * as accountToken from './account_token';
export * as agreement from './agreement';
export * as allowedActionable from './allowed_actionable';
export * as attachment from './attachment';
export * as author from './author';
export * as balanceEvent from './balance_event';
export * as billingGroup from './billing_group';
export * as booking from './booking';
export * as chat from './chat';
export * as chatMessage from './chat_message';
export * as chatReaction from './chat_reaction';
export * as chatUser from './chat_user';
export * as collection from './collection';
export * as competition from './competition';
export * as country from './country';
export * as creditNote from './credit_note';
export * as dataImport from './data_import';
export * as discount from './discount';
export * as event from './event';
export * as eventCarpool from './event_carpool';
export * as eventCarpoolRequest from './event_carpool_request';
export * as eventComment from './event_comment';
export * as eventImport from './event_import';
export * as eventLog from './event_log';
export * as eventReport from './event_report';
export * as eventSeries from './event_series';
export * as eventSeriesUser from './event_series_user';
export * as eventUser from './event_user';
export * as exercise from './exercise';
export * as exerciseDrawing from './exercise_drawing';
export * as externalService from './external_service';
export * as form from './form';
export * as formField from './form_field';
export * as formFieldOption from './form_field_option';
export * as formSubmissonValue from './form_submission_value';
export * as formProductPrice from './form_product_price';
export * as formCategory from './form_category';
export * as formSubmission from './form_submission';
export * as poll from './poll';
export * as tryoutUser from './tryout_user';
export * as formEvent from './form_event';
export * as formEventGroup from './form_event_group';
export * as formEventGroupWaitlistEntry from './form_event_group_waitlist_entry';
export * as formPackage from './form_package';
export * as formPackageProduct from './form_package_product';
export * as formPackagePaymentOption from './form_package_payment_option';
export * as formPaymentOptionPrice from './form_payment_option_price';
export * as game from './game';
export * as gameEvent from './game_event';
export * as gameStatisticsTable from './game_stat_table';
export * as gameReport from './game_report';
export * as gameTeam from './game_team';
export * as group from './group';
export * as groupContactInformation from './group_contact_information';
export * as groupLink from './group_link';
export * as groupLinkFolder from './group_link_folder';
export * as groupPaymentConfig from './group_payment_config';
export * as groupPost from './group_post';
export * as groupPostComment from './group_post_comment';
export * as evaluation from './evaluation';
export * as evaluationCycle from './evaluation_cycle';
export * as evaluationRun from './evaluation_run';
export * as groupSettings from './group_settings';
export * as identityProvider from './identity_provider';
export * as integrationConnection from './integration_connection';
export * as invopop from './invopop';
export * as language from './language';
export * as libraryTag from './library_tag';
export * as lineup from './lineup';
export * as membership from './membership';
export * as onboardingInfo from './onboarding_info';
export * as opponent from './opponent';
export * as opponentPlayer from './opponent_player';
export * as order from './order';
export * as orderCharge from './order_charge';
export * as orderRefund from './order_refund';
export * as orderReport from './order_report';
export * as orderRow from './order_row';
export * as organization from './organization';
export * as organizationLink from './organization_link';
export * as paymentMethod from './payment_method';
export * as paymentPreview from './payment_preview';
export * as paymentStatus from './payment_status';
export * as payout from './payout';
export * as payoutRow from './payout_row';
export * as performanceReview from './performance_review';
export * as position from './position';
export * as practicePlan from './practice_plan';
export * as product from './product';
export * as productCategory from './product_category';
export * as productPrice from './product_price';
export * as providerSettings from './provider_settings';
export * as ratingItem from './rating_item';
export * as resource from './resource';
export * as resourceCategory from './resource_category';
export * as resourceLocation from './resource_location';
export * as schedule from './schedule';
export * as scheduleItem from './schedule_item';
export * as session from './session';
export * as sessionBlock from './session_block';
export * as sessionBlockItem from './session_block_item';
export * as sessionGroup from './session_group';
export * as sport from './sport';
export * as site from './site';
export * as siteGroup from './site_group';
export * as siteGroupContactPerson from './site_group_contact_person';
export * as siteGroupPlayer from './site_group_player';
export * as subscription from './subscription';
export * as tag from './tag';
export * as teamInvitation from './team_invitation';
export * as taxRate from './tax_rate';
export * as trainingCollection from './training_collection';
export * as tournament from './tournament';
export * as user from './user';
export * as userActivity from './user_activity';
export * as userAddress from './user_address';
export * as userFieldCategories from './user_field_categories';
export * as userFields from './user_fields';
export * as userGoal from './user_goal';
export * as userImport from './user_import';
export * as userLog from './user_log';
export * as userProduct from './user_product';
export * as userRating from './user_rating';
export * as video from './video';
export * as videoCollection from './video_collection';
export * as videoPlaylist from './video_playlist';
export * as videoSequence from './video_sequence';
export * as wallet from './wallet';

export interface APIError {
	error: string;
}

/**
 *	Sharing options for models
 */
export enum SharedWith {
	Account = 'only_you',
	Group = 'team',
	Club = 'club',
}
